import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_QUANLYCONGVIEC } from "actions/QuanLyCongViec/actionTypes";
import {
  getListQuanLyCongViecSuccess,
  getListQuanLyCongViecFailure,
} from "actions/QuanLyCongViec";
import QuanLyCongViecApi from "service/quanLyCongViecApi";
import { pushNotification } from "utils/notifications";

function* getListQuanLyCongViec(action) {
  try {
    const response = yield call(QuanLyCongViecApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListQuanLyCongViecSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListQuanLyCongViecFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListQuanLyCongViecFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_QUANLYCONGVIEC, getListQuanLyCongViec);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
